<script>
	import { sCaptcha } from '../stores';
	// Auto-subscription only works with store variables that are declared (or imported) at the top-level scope of a component.

	import { onMount, afterUpdate } from 'svelte';
	import { gerarStringAleatoria } from '../utils';

	export let tamanho = 3;

	function gerarCaptcha() {
		let canvas = '';
		let contexto = '';

		// limpa o conteúdo do elemento
		document.getElementById("captcha").innerHTML = "";
		
		canvas = document.createElement("canvas");
		canvas.id = "CanvasCaptcha";

		// nos testes a largura ideal pro tamanho de 6 caracteres do canvas ficou em 170, para tornar a função mais genérica, dividi 170 por 6 e achei um valor ideal pra independente do tamanho do captcha, o canvas vai ter uma largura ideal pra ele (altura é fixa) ... no mais é questão de layout e adaptar o captcha ao layout pra não gerar quebras indesejadas.
		canvas.width = Math.round(tamanho * 64);
		canvas.height = 50;

		contexto = canvas.getContext("2d");

		// tamanho da fonte implica na questão da largura acima, se trocar o tamanho, será necessário refazer o cálculo do número pra largura ideial automática.
		contexto.font = "50px Georgia";
		contexto.textAlign = "center"; 
		contexto.letterSpacing = "10px";
		contexto.strokeText($sCaptcha, Math.round(tamanho * 32), 38);

		// adiciona o canvas gerado dentro do elemento informado no parâmetro
		document.getElementById("captcha").appendChild(canvas);
	}

	onMount(() => {
		$sCaptcha = gerarStringAleatoria(tamanho);
		gerarCaptcha();
	});
	
	afterUpdate(() => {
		gerarCaptcha();
	});
</script>

<style>
	#captcha {
		border: 1px solid #7600b6;
		margin-top: 2px;
		border-radius: 4px;
	}

	.grid {
		background-image:
			repeating-linear-gradient(0deg, transparent, transparent 7px, #CCC 7px, #CCC 8px),
			repeating-linear-gradient(-90deg, transparent, transparent 7px, #CCC 7px, #CCC 8px);
		background-size: 8px 8px;
	}
</style>

<div id="captcha" class="grid"></div>